import React__default from 'react';
import { useProductDetailSlots } from '@grandvisionhq/fun-products';
import { UnpublishedPDP } from '../UnpublishedPDP.js';
import { useProductDetailContext } from '../../Context/ProductDetailContext.js';

const UnpublishedPDPGuard = ({ children , brandPromotions ,  })=>{
    const { product , activeVariant , productUrl  } = useProductDetailContext();
    const { Slots  } = useProductDetailSlots();
    return !product.published || !activeVariant.isPublished ? /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, /*#__PURE__*/ React__default.createElement(UnpublishedPDP, {
        productUrl: productUrl,
        brandPromotions: brandPromotions
    }), Slots.SecondaryProductInfoSlotB && /*#__PURE__*/ React__default.createElement(Slots.SecondaryProductInfoSlotB, null)) : /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, children);
};

export { UnpublishedPDPGuard };
//# sourceMappingURL=UnpublishedPDPGuard.js.map
